import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Mail, Lock, ArrowRight } from 'lucide-react';
import { login } from '../actions/authAction';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const dispatch = useDispatch();
  const authState = useSelector(state => state.auth);

  useEffect(() => {
    if (authState.isAuthenticated) {
      alert('Login successful!');
    }
  }, [authState.isAuthenticated]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login(credentials));
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <div className="w-full max-w-[400px] bg-white border border-slate-200 rounded-2xl shadow-[0_1px_2px_rgba(15,23,42,0.04),0_12px_28px_rgba(15,23,42,0.06)] p-10">
        <div className="flex justify-center mb-7">
          <img src="/assets/img/logo.png" alt="SLTravel" className="h-8 w-auto" />
        </div>

        <h2 className="text-2xl font-bold text-center text-slate-900">
          Welcome Back
        </h2>
        <p className="mt-2 mb-7 text-sm text-center text-slate-500">Sign in to continue</p>

        {authState.error && (
          <div className="px-3 py-2.5 mb-5 text-sm text-red-700 bg-red-50 border border-red-100 rounded-lg">
            {authState.error}
          </div>
        )}

        <form method="POST" action="#" className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="block mb-1.5 text-xs font-semibold text-slate-700" htmlFor="username">Email address</label>
            <div className="relative">
              <Mail size={18} className="absolute -translate-y-1/2 pointer-events-none left-3 top-1/2 text-slate-400" />
              <input
                placeholder="you@sltravel.com"
                className="w-full h-[46px] pl-10 pr-3.5 border border-slate-200 rounded-lg text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue transition-colors"
                required
                autoComplete="text"
                type="text"
                name="username"
                id="username"
                value={credentials.username}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <label className="block mb-1.5 text-xs font-semibold text-slate-700" htmlFor="password">Password</label>
            <div className="relative">
              <Lock size={18} className="absolute -translate-y-1/2 pointer-events-none left-3 top-1/2 text-slate-400" />
              <input
                placeholder="••••••••••"
                className="w-full h-[46px] pl-10 pr-3.5 border border-slate-200 rounded-lg text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue transition-colors"
                required
                autoComplete="current-password"
                type="password"
                name="password"
                id="password"
                value={credentials.password}
                onChange={handleChange}
              />
            </div>
          </div>

          <button
            className="flex items-center justify-center w-full gap-2 h-12 mt-2 text-sm font-semibold text-white transition-colors rounded-lg bg-brand-blue hover:bg-brand-blue-dark"
            type="submit"
          >
            Sign In
            <ArrowRight size={16} />
          </button>
        </form>

        <p className="mt-5 text-xs text-center text-slate-500">
          Having trouble signing in? Contact your administrator.
        </p>
      </div>
    </div>
  );
};

export default Login;
